/* istanbul ignore file */
import arrowToBottomIcon from '../../assets/arrow-to-bottom.svg';
import { InputLoader } from 'framework/ui/mui-builder';
import { useUiTheme } from 'framework/uiTheme';

type DownloadButtonProps = {
  onClick: () => void;
  loading: boolean;
};

const DownloadButton = ({ onClick, loading }: DownloadButtonProps) => {
  const { InputLoader: ThemedInputLoader = InputLoader } = useUiTheme();
  return (
    <button type="button" onClick={onClick}>
      {loading ? (
        <ThemedInputLoader className="files-list__files-loader" />
      ) : (
        <span className="files-list__files-download">
          <img src={arrowToBottomIcon} alt="Download" title="Download" />
        </span>
      )}
    </button>
  );
};

export default DownloadButton;
